import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import Placeholder from '../../../assets/images/placeholderAvatar.svg';
import { Tag } from '../styledComponents';
import { FixBannerPageLayout } from '../../common/Mobile/FixBannerPageLayout';
import { Avatar, Button, Typography } from '@mui/material';
import { styled as styledMUI } from '@mui/material/styles';
import { ContentSection } from '../../common/Mobile/ContentSection';
import { TopCategories } from './components/TopCategories';
import {
  Body12,
  Body8,
  Header18,
  Header20,
  Subheader14,
  Subheader22,
} from '../../common/Typography';
import useFetchReviews from '../../review/useFetchReviews';
import { NoDataYet, SubHeader } from './styles';
import { THEME_COLORS } from '../../common/colors';
import { getCategoryLabelsFromAssets } from '../../common/utils';
import PlaceIcon from '@mui/icons-material/LocationOnRounded';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ArrowIcon from '@mui/icons-material/ArrowForwardIosRounded';
import { useHistory } from 'react-router-dom';
import { ActiveOfferList } from './ActiveOfferList';
import ActionMenuModal from '../../common/Mobile/ActionMenuModal';
import { AssetListMobile } from './components/AssetListMobile';
import IconButton from '@mui/material/IconButton';
import { useIsAlreadyFollowing } from '../../follow/useIsAlreadyFollowing';
import { useFollow } from '../../follow/useFollow';
import { RecentSuaps } from './RecentSuap';
import { useGetFollowingsInfo } from '../../follow/useGetFollowingInfo';
import { FollowersList } from './components/FollowersList';
import { AddNewAssetCard } from '../components/AddNewAssetCard';
import Stack from '@mui/material/Stack';
import { useAuth0 } from '@auth0/auth0-react';
import { Popover } from '../../common/Popover';
import { InviteLinkModal } from './components/inviteLinkModal';
import { ARCHETYPE_DECORATOR } from '../constants';
import { SuggestedAssetList } from '../../assets/components/SuggestedAssetList';

const Header = styled.div`
  h1 {
    width: 100%;
    text-align: center;
  }
`;

const Subheader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  div {
    text-align: center;
  }
`;

const Location = styled(Body12)`
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
`;

const Archetype = styled(Subheader22)`
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
`;

const LocationIcon = styled(PlaceIcon)`
  fill: #717273 !important;
`;

const CategoryList = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

const ActionButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin: 1rem 0 1.5rem 0;
`;

const CategoryTag = styled(Tag)`
  background-color: ${THEME_COLORS.primary}20;
  padding: 4px;
  font-size: 0.83rem;
  border-radius: 4px;
  min-width: 10px;
`;

const UserDisplayName = styled(Header20)`
  display: inline-block;
  color: #4e5152 !important;
  line-height: 16px;
`;

const ProfilePicture = styled(Avatar)`
  margin: -72px auto 0 auto !important;
  max-width: 250px !important;
  max-height: 250px !important;
  width: CALC(100vw / 3) !important;
  height: CALC(100vw / 3) !important;
  border: 2px solid #fff !important;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  img {
    width: 110%;
    height: 110%;
  }
`;

const ProfileLabel = styled(SubHeader)`
  margin-bottom: 0.6rem !important;
  font-weight: 800 !important;
`;

const EditButton = styledMUI(Button)(({ width }) => ({
  color: THEME_COLORS.primary,
  textTransform: 'capitalize',
  fontWeight: '400',
  minWidth: 25,
  border: `1px solid ${THEME_COLORS.primary}`,
  backgroundColor: '#fff',
  borderRadius: 4,
  width: `${width}%`,
  boxShadow: 'unset',
  '&:hover': {
    backgroundColor: `${THEME_COLORS.subdued}10`,
  },
}));

const PublicButton = styledMUI(Button)(({ width }) => ({
  color: '#fff',
  textTransform: 'capitalize',
  fontWeight: '400',
  minWidth: 25,
  backgroundColor: THEME_COLORS.primary,
  borderRadius: 4,
  width: `${width}%`,
  boxShadow: 'unset',
  '&:hover': {
    backgroundColor: THEME_COLORS.primaryHover,
  },
}));

const MenuContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const currentFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const AssetSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 8px;
`;

const EmptyAsset = styled.div`
  width: 46%;
  height: 56px;
  background-color: #fafafa;
  border-radius: 4px;
`;

const EmptyAssetContainer = styled(Stack)`
  width: 100% !important;
  margin: 4px 8px !important;
`;

const InviteLink = styled(Popover)`
  margin-left: -9px !important;
  .share-content-pop-over {
    transform: translate3d(463px, -139px, 0px) !important;
  }
`;

const SuggestedList = styled.div`
  max-height: 800px;
  overflow-y: auto;
`;

function getProfileActions(history, userUuid, logout) {
  return [
    {
      label: 'View public profile',
      action: () => history.push(`/profile/${userUuid}`),
    },
    {
      label: 'View history',
      action: () => null,
      type: 'disabled',
      description: 'Feature coming soon!',
    },
    {
      label: 'Log out',
      type: 'error',
      action: e => {
        e.preventDefault();
        logout();
        localStorage.removeItem('token');
        localStorage.removeItem('skipGoalForNow');
        localStorage.removeItem('dismissedAutoHowToPopup');
        window.location = '/?message=logout_success';
      },
    },
  ];
}
export function MobileProfilePage({
  type,
  user = {},
  userLookingForList = [],
  categories = [],
  userAssets = [],
  contractDetails = [],
  suapMetrics = {},
  isCurrentUser,
  userInfo,
  openAssetForm,
}) {
  const { logout } = useAuth0();
  const history = useHistory();
  const { reviews } = useFetchReviews('user', user.uuid);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [copySuccess, setCopySuccess] = useState(false);
  const archetype = user.interests?.[0]
    ? user.interests?.[0].replace('You got: ', '')
    : '';
  const archetypeDecorator = archetype ? ARCHETYPE_DECORATOR[archetype] : {};
  const archetypeBestMatchDecorator = archetype
    ? ARCHETYPE_DECORATOR[archetypeDecorator.bestMatch]
    : {};

  const handleInviteClick = useCallback(
    event => {
      setAnchorEl(anchorEl ? null : event.currentTarget);
    },
    [anchorEl],
  );

  const {
    followersCount,
    followers,
    followingsCount,
    followings,
  } = useGetFollowingsInfo(user.id);
  const [followType, setFollowType] = useState(null);

  const [openModal, setOpenModal] = useState(false);
  const {
    isFollowing,
    loading: checking,
    setIsFollowing,
  } = useIsAlreadyFollowing(user.id, isCurrentUser);
  const followCallback = (_, bool) => {
    setIsFollowing(bool);
  };

  const { follow, loading, unfollow } = useFollow(followCallback);
  return (
    <FixBannerPageLayout
      colors={
        archetype
          ? [archetypeDecorator.color, archetypeDecorator.secondaryColor]
          : []
      }
      color="gray"
      iconOnly={true}
      expanded="true"
    >
      <ProfilePicture
        variant="round"
        src={user.profilepicture || archetypeDecorator.image || Placeholder}
      />
      <Header>
        <UserDisplayName component="h1">
          {user.firstname} {user.surname}
        </UserDisplayName>
      </Header>
      {archetype && (
        <>
          <Archetype>
            <span style={{ color: archetypeDecorator.color }}>
              {archetypeDecorator.icon} {archetype}
            </span>
          </Archetype>
          <Location
            variant="body1"
            sx={{
              marginBottom: '1.3rem !important',
              textAlign: 'center !important',
            }}
          >
            Strengths: {archetypeDecorator.strengths}
          </Location>
        </>
      )}
      {!archetype && (
        <Location variant="body1" gutterBottom>
          <LocationIcon fontSize="small" />
          {user.displaylocation || 'No Location'}
        </Location>
      )}
      {type === 'public' && !!userAssets.length && (
        <CategoryList>
          {(getCategoryLabelsFromAssets(categories, userAssets) ?? []).map(
            (category, i) => (
              <CategoryTag key={`${category}-${i}`}>
                #{category.toLowerCase()}
              </CategoryTag>
            ),
          )}
        </CategoryList>
      )}
      {!!suapMetrics.completedSuapsCount && (
        <div style={{ textAlign: 'center', margin: '1rem auto' }}>
          {!!suapMetrics.completedSuapsCount && (
            <Header18>
              {currentFormatter.format(suapMetrics.totalSavings)}
            </Header18>
          )}
          <Subheader14>Savings so far</Subheader14>
        </div>
      )}
      {type === 'view' && (
        <ActionButtonContainer>
          <EditButton width={95} onClick={() => history.push('/profile/edit')}>
            Edit profile
          </EditButton>
          <EditButton width={95} onClick={handleInviteClick}>
            Share my profile
          </EditButton>
          <EditButton width={5} onClick={() => setOpenModal(true)}>
            <MoreVertIcon sx={{ fill: `${THEME_COLORS.primary} !important` }} />
          </EditButton>
          {anchorEl && (
            <InviteLink
              open={anchorEl}
              anchorEl={anchorEl}
              onClose={() => setAnchorEl(null)}
              isMobile={true}
              placement="bottom-start"
            >
              <InviteLinkModal
                inviteLink={`${process.env.REACT_APP_PUBLIC_URL}/user-offerings/${user.uuid}`}
                copySuccess={copySuccess}
                setCopySuccess={setCopySuccess}
              />
            </InviteLink>
          )}
        </ActionButtonContainer>
      )}
      {type === 'public' && (
        <Typography
          sx={{ whiteSpace: 'pre-wrap', textAlign: 'center', margin: '2rem 0' }}
          variant="body1"
          gutterBottom
        >
          {user.description || 'No bio yet.'}
        </Typography>
      )}
      {type === 'public' && (
        <ActionButtonContainer>
          <PublicButton width={95} onClick={handleInviteClick}>
            Share profile
          </PublicButton>
          <InviteLink
            open={anchorEl}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            isMobile={true}
            placement="bottom-start"
          >
            <InviteLinkModal
              inviteLink={`${process.env.REACT_APP_PUBLIC_URL}/profile/${user.uuid}`}
              copySuccess={copySuccess}
              setCopySuccess={setCopySuccess}
            />
          </InviteLink>
          {false && (
            <>
              {!isFollowing && (
                <PublicButton
                  variant="contained"
                  width={50}
                  disabled={isCurrentUser || checking}
                  loading={loading}
                  onClick={isCurrentUser ? undefined : () => follow(user.id)}
                >
                  Follow
                </PublicButton>
              )}
              {isFollowing && (
                <PublicButton
                  variant="contained"
                  width={50}
                  loading={loading}
                  onClick={() => unfollow(user.id)}
                >
                  Unfollow
                </PublicButton>
              )}
              <PublicButton
                variant="contained"
                width={50}
                onClick={() => history.push(`/user-offerings/${user.uuid}`)}
              >
                View suap wallet
              </PublicButton>
            </>
          )}
        </ActionButtonContainer>
      )}
      {false && (
        <Subheader>
          <div>
            <Header18>{reviews.userReviewAverage}</Header18>
            <Subheader14>ratings</Subheader14>
          </div>
          <div onClick={() => setFollowType('Followers')}>
            <Header18>{followersCount || '-'}</Header18>
            <Subheader14>followers</Subheader14>
          </div>
          <div onClick={() => setFollowType('Following')}>
            <Header18>{followingsCount || '-'}</Header18>
            <Subheader14>following</Subheader14>
          </div>
        </Subheader>
      )}
      {archetype && (
        <ContentSection>
          <ProfileLabel>
            Best match:{' '}
            <span style={{ color: archetypeBestMatchDecorator.color }}>
              {archetypeDecorator.bestMatch}
            </span>
          </ProfileLabel>
          <Subheader14 as="span">{archetypeDecorator.matchReason}</Subheader14>
        </ContentSection>
      )}
      {type === 'view' && (
        <ContentSection>
          <ProfileLabel>Findings for you</ProfileLabel>
          <SuggestedList>
            <SuggestedAssetList isMobile={true} userUuid={user.uuid} />
          </SuggestedList>
        </ContentSection>
      )}
      <ContentSection>
        <TopCategories
          user={user}
          color={
            archetypeDecorator.color
              ? `${archetypeDecorator.color}20`
              : undefined
          }
          userLookingForList={userLookingForList ?? []}
          viewType={type}
        />
      </ContentSection>
      {archetype && user.sexualorientation.length > 0 && (
        <ContentSection>
          <ProfileLabel>My skills</ProfileLabel>
          {user.sexualorientation?.map(value => {
            return (
              <Tag key={`${value}-tag`} color={`${archetypeDecorator.color}20`}>
                {value}
              </Tag>
            );
          })}
        </ContentSection>
      )}
      <ContentSection>
        <MenuContainer>
          <ProfileLabel>My offerings</ProfileLabel>
          <IconButton
            onClick={() =>
              history.push(
                type === 'view'
                  ? '/my-offerings'
                  : `/user-offerings/${user.uuid}`,
              )
            }
            type="button"
            aria-label="active-menu-action"
          >
            View All{' '}
            <ArrowIcon sx={{ padding: 0, marginBottom: '0.6rem !important' }} />
          </IconButton>
        </MenuContainer>
        {type === 'view' && userAssets.length === 0 && (
          <AssetSection>
            {type === 'newAccount' && (
              <Body8>Products, services and skills I will offer</Body8>
            )}
            <AddNewAssetCard
              hideTitle
              size="mobile-thumbnail"
              openAssetForm={openAssetForm}
            />
            <EmptyAssetContainer
              spacing={1}
              direction="row"
              useFlexGap
              flexWrap="wrap"
            >
              <EmptyAsset />
              <EmptyAsset />
              <EmptyAsset />
              <EmptyAsset />
            </EmptyAssetContainer>
          </AssetSection>
        )}
        {userAssets?.length !== 0 && (
          <AssetListMobile userAssets={userAssets} />
        )}
      </ContentSection>
      {false && (
        <ContentSection>
          <div>
            <ProfileLabel>When I suap, I value</ProfileLabel>
            <div>
              {user.profilevalues?.length > 0 ? (
                user.profilevalues?.map(value => {
                  return <Tag key={`${value}-tag`}>{value}</Tag>;
                })
              ) : (
                <NoDataYet>No values added yet</NoDataYet>
              )}
            </div>
          </div>
        </ContentSection>
      )}
      {type === 'public' && (
        <ContentSection>
          <ProfileLabel>Recent Suaps</ProfileLabel>
          {contractDetails?.length > 0 ? (
            <RecentSuaps
              recentSuaps={contractDetails}
              user={user}
              isMobile={true}
            />
          ) : (
            'No recent suaps yet.'
          )}
        </ContentSection>
      )}
      <FollowersList
        followingContent={
          followType === 'Followers'
            ? followers
            : followType === 'Following'
            ? followings
            : []
        }
        title={followType}
        isOpen={!!followType}
        follow={follow}
        unfollow={unfollow}
        onClose={() => setFollowType(null)}
        userInfo={userInfo}
        isCurrentUser={isCurrentUser}
        isMobile={true}
      />
      {openModal && (
        <ActionMenuModal
          options={getProfileActions(history, user.uuid, logout)}
          onClose={() => setOpenModal(false)}
        />
      )}
    </FixBannerPageLayout>
  );
}
